(() => {
class WfRegionalSectors extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;

    this.abortController = new AbortController();
    const signal = this.abortController.signal;

    this.track = this.querySelector('.wf-home-regional__sectors-list');
    this.items = Array.from(this.querySelectorAll('.wf-home-regional__sector-item'));
    this.dots = Array.from(this.querySelectorAll('.wf-home-regional__sectors-dot'));
    this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!this.track || this.items.length === 0 || this.dots.length === 0) return;

    this.visibility = new Array(this.items.length).fill(false);

    this.observer = new IntersectionObserver(this.handleIntersect, {
      root: this.track,
      threshold: 0.6,
    });
    this.items.forEach((item) => this.observer.observe(item));

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.scrollToIndex(index), { signal });
    });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.abortController?.abort();
    this.abortController = null;
  }

  handleIntersect = (entries) => {
    entries.forEach((entry) => {
      const index = this.items.indexOf(entry.target);
      if (index !== -1) this.visibility[index] = entry.isIntersecting;
    });

    const leadingIndex = this.visibility.indexOf(true);
    if (leadingIndex !== -1) this.setActiveIndex(leadingIndex);
  };

  setActiveIndex(index) {
    this.dots.forEach((dot, dotIndex) => {
      dot.setAttribute('aria-current', String(dotIndex === index));
    });
  }

  scrollToIndex(index) {
    const item = this.items[index];
    if (!item || !this.track) return;

    this.track.scrollTo({
      left: item.offsetLeft - this.track.offsetLeft,
      behavior: this.motionPreference.matches ? 'auto' : 'smooth',
    });
  }
}

if (!customElements.get('wf-regional-sectors')) {
  customElements.define('wf-regional-sectors', WfRegionalSectors);
}
})();
